var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.class_cont},[_c('BPIdLayout',{attrs:{"layout":_vm.layout,"objects":_vm.objects},scopedSlots:_vm._u([{key:"element",fn:function({ data }){return [_c('Chart',{class:_vm.class_chart,attrs:{"title":data.title,"chardata":data.chartdata,"type":data.type}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }